import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  featureManagementTab: {
    id: 'dXOtmA',
    defaultMessage: 'Feature Management',
    description: 'Label for the Feature Management tab in Loss Prevention settings',
  },
  blacklistManagementTab: {
    id: 'cLIW9Y',
    defaultMessage: 'Blacklist Management',
    description: 'Label for the Blacklist Management tab in Loss Prevention settings',
  },
  metricsAnalyticsTab: {
    id: 'oE9dQi',
    defaultMessage: 'Metrics & Analytics',
    description: 'Label for the Metrics & Analytics tab in Loss Prevention settings',
  },
});
